import * as yup from 'yup';

const validationSchema = yup.object({
  quantity: yup
    .number()
    .typeError('Quantity must be a number')
    .integer('Quantity must be a whole number')
    .min(1, 'Quantity must be at least 1')
    .required('Quantity is required'),
});

export default validationSchema;
